// NingalooCoralBay (RezExpert on online.rezexpert.com) booking strategy.
//
// URL shape:
//   ${site.reserveUrl}&open_date=YYYY-MM-DDT00:00:00&days=<stay>&oids=<ids>&oa=<amounts>
//
// Occupant ids are per-business on this deployment: the Bayview park
// (business_code=5128) uses Adult/Children/Infant = 506/507/508, while the
// Backpackers hostel (500383) has a single "Person(s)" occupant = 527.

import { format } from "date-fns";
import { resolveMinStayLength, resolveMinCapacity } from "./_context.js";

const BACKPACKERS_CODE = "business_code=500383";

export default {
  bookingInstructions(ctx) {
    if (!ctx.site.hasCapacity) return null;
    const beds = resolveMinCapacity(ctx);
    return `On the booking page, leave Person(s) at 1 and select ${beds} ${beds === 1 ? "bed" : "beds"} in Quantity for ${ctx.site.name}.`;
  },

  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const stay = resolveMinStayLength(ctx);
    // For bed inventory, oa is occupants PER BED. The customer chooses
    // their number of beds in the provider's Quantity control.
    const capacity = site.hasCapacity ? 1 : resolveMinCapacity(ctx);
    const dateParams = `open_date=${format(arrivalDate, "yyyy-MM-dd")}T00:00:00&days=${stay}`;
    const occupantParams = site.reserveUrl.includes(BACKPACKERS_CODE)
      ? `oids=527&oa=${capacity}`
      : `oids=506,507,508&oa=${capacity},0,0`;
    return `${site.reserveUrl}&${dateParams}&${occupantParams}`;
  },

  // The per-site reserveUrl carries &utids=<typeId>, which filters the
  // booking page to a single unit type — not an overview. Strip it so
  // "View map" lands on the whole park's search page.
  buildPreviewUrl(site) {
    return site.reserveUrl.replace(/&utids=[^&]*/, "");
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &open_date=YYYY-MM-DDT00:00:00.",
        },
        departureDate: {
          status: "required",
          notes: "Used to derive &days=<nights>.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the unit type.",
        },
        partySize: {
          status: "optional",
          defaultValue: 1,
          notes:
            "Whole units use oa for party size. Bed inventory uses oa=1; select the requested number of beds in Quantity on the provider page.",
        },
      },
    };
  },
};
